var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagEthiopia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 17.9572 0.352062 19.832 0.99525 21.5653L16 22.9565L31.0047 21.5653C31.648 19.832 32 17.9571 32 16C32 14.0696 31.6581 12.2192 31.0316 10.5059L16 9.04346L0.968375 10.506C0.341938 12.2192 0 14.0696 0 16H0Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32C22.8794 32 28.7441 27.658 31.0048 21.5652H0.995186C3.25587 27.658 9.12056 32 16 32Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0C9.12056 0 3.25587 4.342 0.995186 10.4348H31.0049C28.7441 4.342 22.8794 0 16 0Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 23.6523C20.2262 23.6523 23.6522 20.2263 23.6522 16.0001C23.6522 11.7739 20.2262 8.3479 16 8.3479C11.7738 8.3479 8.34781 11.7739 8.34781 16.0001C8.34781 20.2263 11.7738 23.6523 16 23.6523Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.998 10.0745L17.3794 14.3258H21.8567L18.2331 16.9534L19.6253 21.2174L15.998 18.5773L12.3763 21.2125L13.7629 16.9534L10.1426 14.3258H14.6166L15.998 10.0745Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5077 17.0582L17.1254 15.6342L19.8337 11.9067L18.7083 11.0889L15.9998 14.8166L13.2916 11.0889L12.166 11.9067L14.8742 15.6345L10.4922 17.0582L10.9221 18.3815L15.3043 16.9577V21.5653H16.6956V16.9576L21.0776 18.3815L21.5077 17.0582Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagEthiopia);
export default __webpack_public_path__ + "static/media/flag_ethiopia.9a4dd7887e04b5dcaa57654ab220b1e1.svg";
export { ForwardRef as ReactComponent };